var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0C22 0 26.6667 1.83333 26.6667 4.16667V6.66667C27.5885 6.66667 28.3333 7.41146 28.3333 8.33333V11.6667C28.3333 12.5885 27.5885 13.3333 26.6667 13.3333V21.6667C26.6667 22.5885 25.9219 23.3333 25 23.3333V25C25 25.9219 24.2552 26.6667 23.3333 26.6667H21.6667C20.7448 26.6667 20 25.9219 20 25V23.3333H9.99999V25C9.99999 25.9219 9.2552 26.6667 8.33332 26.6667H6.66666C5.74478 26.6667 4.99999 25.9219 4.99999 25V23.3333C4.07968 23.3333 3.33332 22.5885 3.33332 21.6667V13.3333C2.41301 13.3333 1.66666 12.5885 1.66666 11.6667V8.33333C1.66666 7.41146 2.41301 6.66667 3.33332 6.66667V4.16667C3.33332 1.83333 7.99999 0 15 0ZM6.66666 13.3333C6.66666 14.2552 7.41145 15 8.33332 15H14.1667V6.66667H8.33332C7.41145 6.66667 6.66666 7.41146 6.66666 8.33333V13.3333ZM15.8333 15H21.6667C22.5885 15 23.3333 14.2552 23.3333 13.3333V8.33333C23.3333 7.41146 22.5885 6.66667 21.6667 6.66667H15.8333V15ZM7.49999 20.8333C8.42187 20.8333 9.16666 20.0885 9.16666 19.1667C9.16666 18.2448 8.42187 17.5 7.49999 17.5C6.57812 17.5 5.83332 18.2448 5.83332 19.1667C5.83332 20.0885 6.57812 20.8333 7.49999 20.8333ZM22.5 20.8333C23.4219 20.8333 24.1667 20.0885 24.1667 19.1667C24.1667 18.2448 23.4219 17.5 22.5 17.5C21.5781 17.5 20.8333 18.2448 20.8333 19.1667C20.8333 20.0885 21.5781 20.8333 22.5 20.8333ZM19.1667 3.33333H10.8333C10.375 3.33333 9.99999 3.70625 9.99999 4.16667C9.99999 4.62708 10.375 5 10.8333 5H19.1667C19.625 5 20 4.62708 20 4.16667C20 3.70625 19.625 3.33333 19.1667 3.33333Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 26.6667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/Bus.72aabab9.svg";
export { ForwardRef as ReactComponent };